import Modal from '@/components/Modal'
import Flex from '@/elements/Flex'
import { startAuth } from '@/stores/authStore'
import Button from '@/elements/Button'
import { AppleLogo, GoogleLogo } from '@/assets'

interface AuthModalProps {
  isOpen: boolean
  onClose: () => void
}

function AuthModal({ isOpen, onClose }: AuthModalProps) {
  return (
    <Modal title='Authenticate with Fuzzy' isOpen={isOpen} onCancel={onClose} className='auth-modal'>
      <Flex
        wfull
        align='center'
        justify='center'
        p={2} pb={3} gap={4}
      >
        <Button variant='secondary' onClick={() => startAuth('apple')} styles={{ width: '100%' }}>
          <AppleLogo width={30} height={30} fill='currentColor' />
          Log in with Apple ID
        </Button>

        <Button variant='secondary' onClick={() => startAuth('google')} styles={{ width: '100%' }}>
          <GoogleLogo width={22} height={22} fill='currentColor' />
          Log in with Google
        </Button>
      </Flex>
    </Modal>
  )
}

export default AuthModal
